export const CLIENT_BOOKING_KLARNA_TEST_KEY = 'enable_klarna_payments_ev3903_20220818';
export const CLIENT_BOOKING_KLARNA_TEST_PERCENT = 1.0;
export const CLIENT_BOOKING_KLARNA_TIPPING_TEST_KEY = 'client_klarna_show_tip_modal_20220608';
export const CLIENT_BOOKING_KLARNA_TIPPING_TEST_PERCENT = 0.5;
export const KLARNA_ANNOUNCEMENT_FLAG = 'pro_klarnaannouncement_ev3653_20220120';
export const KLARNA_ANNOUNCEMENT_KEY = 'pro_klarnaannouncement_seen_ev3653';
export const MAX_ANNOUNCEMENT_SEEN = 3;
export const MIN_ANNOUNCEMENT_INTERVAL = 24; // hours
export const KLARNA_MINIMUM_SERVICE_COST = 40;
export const KLARNA_MAX_DAYS = 28;
export const KLARNA_MAX_COST = 1000;
export enum KLARNA_ANALYTIC_EVENTS {
  VIEWED = 'klarna__viewed',
  CLICKED = 'klarna__clicked',
  SELECTED = 'klarna__selected',
  APPROVED = 'klarna__approved',
  NOT_APPROVED = 'klarna__not-approved',
  PRO_ANNOUNCEMENT_VIEWED = 'pro_klarnaintro__viewed',
  PRO_ANNOUNCEMENT_LINK_CLICKED = 'pro_klarnaintrolink__clicked',
  PRO_ANNOUNCEMENT_CLOSED = 'pro_klarnaintro__closed',
}
export const KLARNA_ERROR_NOT_EDITABLE = 'This appointment is booked and will be paid through Klarna. It cannot be edited.';
export const KLARNA_ERROR_RESCHEDULE_FAILED = 'The appointment could not be rescheduled.';
